import { render, staticRenderFns } from "./AddEnroll.vue?vue&type=template&id=0af99104&scoped=true"
import script from "./AddEnroll.vue?vue&type=script&lang=js"
export * from "./AddEnroll.vue?vue&type=script&lang=js"
import style0 from "./AddEnroll.vue?vue&type=style&index=0&id=0af99104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af99104",
  null
  
)

export default component.exports